'use client';
import Product from '@models/product';
import YoutubeCard from '@components/YoutubeCard';
import ProductCard from '@repo/ui/src/components/ContentGrid/ProductCard';
import LearnCard from '@repo/ui/src/components/Cards/LearnCard';
import RecipeCard from '@repo/ui/src/components/Cards/RecipeCard';
import RecipeCardSimple from '@repo/ui/src/components/Cards/RecipeCardSimple';
import PressArticle from '@repo/ui/src/components/Cards/PressArticle';
import AuthorCard from '@repo/ui/src/components/Cards/AuthorCard';
import WoodPelletFlavor from '@components/WoodPelletFlavors/_WoodPelletFlavor';

import type { CarouselContentSchema, CarouselResolvedItem } from './types';
import type { ProductModelProps } from '@typings/product';

interface Props {
  item: CarouselResolvedItem;
  schema?: CarouselContentSchema;
  saleText?: string;
  newText?: string;
  darkMode?: boolean;
  vip?: boolean;
}

const CarouselItem = ({
  item,
  schema = item._meta?.schema as CarouselContentSchema | undefined,
  saleText,
  newText,
  darkMode,
  vip,
}: Props) => {
  // Each card component expects its own specific props. The schema-based switch
  // guarantees the correct shape at runtime; cast to unknown once so each
  // branch can narrow to the target component's props.
  const data = item as unknown;

  switch (schema) {
    case 'https://traegergrills.com/data/contentTypes/traegerTV.json':
      return <YoutubeCard {...(data as React.ComponentProps<typeof YoutubeCard>)} darkMode={darkMode} />;
    case 'https://traegergrills.com/data/contentTypes/youtubeVideo.json':
      return <YoutubeCard {...(data as React.ComponentProps<typeof YoutubeCard>)} darkMode={darkMode} />;
    case 'https://traegergrills.com/data/contentTypes/pressArticle.json':
      return <PressArticle {...(data as React.ComponentProps<typeof PressArticle>)} />;
    case 'https://traegergrills.com/data/contentTypes/learn.json':
      return <LearnCard {...(data as React.ComponentProps<typeof LearnCard>)} />;
    case 'https://traegergrills.com/data/contentTypes/author.json':
      return <AuthorCard {...(data as React.ComponentProps<typeof AuthorCard>)} />;
    case 'https://traegergrills.com/data/contentTypes/recipe.json':
      return <RecipeCard {...(data as React.ComponentProps<typeof RecipeCard>)} />;
    case 'https://traegergrills.com/data/contentTypes/recipeSimple.json':
      return <RecipeCardSimple {...(data as React.ComponentProps<typeof RecipeCardSimple>)} />;
    case 'https://traegergrills.com/data/contentTypes/woodPelletFlavor.json':
      return <WoodPelletFlavor {...(data as React.ComponentProps<typeof WoodPelletFlavor>)} />;
    case 'https://traegergrills.com/data/contentTypes/product.json':
    default:
      return (
        <ProductCard
          product={item instanceof Product ? item : new Product(item as ProductModelProps)}
          saleText={saleText}
          newText={newText}
          vip={vip}
          className="bg-neutral-100"
        />
      );
  }
};

export default CarouselItem;
